import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApprovePayload } from '../types/filing-obligation.type';

@Injectable({
  providedIn: 'root'
})
export class SysUtilService {

  constructor(private readonly http: HttpClient, @Inject('BASE_URL') private readonly originUrl: string) { }

  public getProgramParam(param_name: string): Observable<any> {
    return this.http.get<any>(this.originUrl + 'api/util/param/' + param_name);
  }

  public getEnv(): Observable<any> {
    return this.http.get<any>(this.originUrl + 'api/util/env/');
  }

  public getCurrentQuarter(): Observable<number> {
    return this.http.get<number>(this.originUrl + 'api/Quarter/Current/');
  }

  public getYear(): Observable<number> {
    return this.http.get<number>(this.originUrl + 'api/Quarter/Year/');
  }

  public getAdminNotes(org: number, qtr: number): Observable<ApprovePayload> {
    return this.http.get<ApprovePayload>(this.originUrl + `api/util/notes/${org}/${qtr}`);
  }

  public updateAdminNotes(org: number, qtr: number, note: string): Observable<any> {
    const responsePayload: ApprovePayload = new ApprovePayload();
    responsePayload.value = note;
    return this.http.put<boolean>(this.originUrl + `api/util/notes/${org}/${qtr}`, responsePayload)
  }
}
